/**
* This file was auto-generated by the FrontendConstantsGenerator.
* Do not make direct changes to the file.
*/

export enum FilterOperators {
  AFTER = '$gt',
  BEFORE = '$lt',
  BETWEEN = '$between',
  CONTAINS_CASE_INSENSITIVE = '$contains_i',
  EQUALS = '$eq',
  EQUALS_CASE_INSENSITIVE = '$eq_i',
  EXCLUDE = '$not_in',
  EXISTS = '$exists',
  GREATER_THAN = '$gt',
  GREATER_THAN_DAYS_AGO = '$gt_days_ago',
  GREATER_THAN_OR_EQUALS = '$gte',
  INCLUDE = '$in',
  LESS_THAN = '$lt',
  LESS_THAN_DAYS_AGO = '$lt_days_ago',
  LESS_THAN_OR_EQUALS = '$lte',
  NOT_CONTAINS_CASE_INSENSITIVE = '$not_contains_i',
  NOT_EQUALS_CASE_INSENSITIVE = '$not_eq_i',
  NOT_EQUALS = '$not_eq',
  NOT_EXISTS = '$not_exists',
}

export enum LogicalOperators {
  
    AND = '$and',
  
    OR = '$or',
  
    NOT = '$not',
  
}
